import { useEffect } from "react";
import styled from "styled-components";
import IconButton from "./Buttons/IconButton";

const Modal = ({
  show,
  onDismiss,
  children,
}: {
  show?: boolean;
  onDismiss?: () => void;
  children: any;
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (onDismiss && event.key === "Escape") {
        onDismiss();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onDismiss]);
  return show ? (
    <>
      <Backdrop onClick={onDismiss} />
      <ModalContainer>
        <ModalCloseButton>
          <IconButton
            onClick={() => onDismiss && onDismiss()}
            icon="cross"
            tooltip="Sluit venster"
          />
        </ModalCloseButton>
        <ModalContent>{children}</ModalContent>
      </ModalContainer>
    </>
  ) : null;
};

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 5px;

  @media only screen and (min-width: 480px) {
    min-width: 516px;
    min-height: 350px;
  }

  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  @media only screen and (max-width: 480px) {
    height: 100%;
    width: 100%;
  }
  z-index: 101;
`;

const ModalContent = styled.div`
  padding: 20px;
  padding-left: 46px;
  padding-right: 46px;
  padding-bottom: 36px;
`;

const ModalHeader = styled.h2`
  top: 0;
  /* Tablet/H2 */
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 120%;

  /* BoerenNatuur Blauw */
  color: #0075bc;
`;
const ModalCloseButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;
const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
`;
const ModalFooter = styled.div`
  position: absolute;
  left: 46px;
  bottom: 36px;
  justify-self: flex-end;
  display: flex;
  flex-direction: row;
`;

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
export default Modal;
